import React from 'react';

export const UserAvatar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.5859 15.5391C14.6875 14.0156 13.0859 13 11.25 13H8.75C6.875 13 5.27344 14.0156 4.41406 15.5391C5.78125 17.0625 7.77344 18 10 18C12.1875 18 14.1797 17.0625 15.5859 15.5391ZM0 10.5C0 6.94531 1.875 3.66406 5 1.86719C8.08594 0.0703125 11.875 0.0703125 15 1.86719C18.0859 3.66406 20 6.94531 20 10.5C20 14.0938 18.0859 17.375 15 19.1719C11.875 20.9688 8.08594 20.9688 5 19.1719C1.875 17.375 0 14.0938 0 10.5ZM10 11.125C10.9766 11.125 11.9141 10.6172 12.4219 9.71875C12.9297 8.85938 12.9297 7.80469 12.4219 6.90625C11.9141 6.04688 10.9766 5.5 10 5.5C8.98438 5.5 8.04688 6.04688 7.53906 6.90625C7.03125 7.80469 7.03125 8.85938 7.53906 9.71875C8.04688 10.6172 8.98438 11.125 10 11.125Z"
      fill="#A3A3A3"
    />
  </svg>
);
